// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, Weaver, WeaverObject, WeaverRole, cuid;

  cuid = require('cuid');

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  GET = Weaver.GET;

  POST = Weaver.POST;

  // For any node, you can specify which users and roles are allowed to read the node, and which users and roles are
  // allowed to modify an node. To support this type of security, each node has an access control list,
  // implemented by the WeaverACL class.
  WeaverRole = class WeaverRole extends WeaverObject {
    constructor(name = 'unnamed') {
      super(cuid(), name);
      // State
      this._stored = false;
      this._deleted = false;
      // Locally these are objects, whereas the server expects arrays
      // Converting to arrays before saving in save function
      this._usersMap = {};
      this._rolesMap = {};
    }

    static loadFromServerObject(roleObject) {
      var i, j, len, len1, ref, ref1, role, u;
      role = new WeaverRole();
      // Copy
      role._id = roleObject.roleId;
      role._name = roleObject.name;
      role._stored = true;
      ref = roleObject.users;
      for (i = 0, len = ref.length; i < len; i++) {
        u = ref[i];
        role._usersMap[u] = true;
      }
      ref1 = roleObject.roles;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        u = ref1[j];
        role._rolesMap[u] = true;
      }
      role._isDomain = roleObject.isDomain != null;
      return role;
    }

    async save() {
      var key, payload, ref, ref1, value;
      this._users = this.getUsers();
      this._roles = this.getRoles();
      if (!this._stored) {
        payload = {
          roleId: this.id(),
          name: this.name()
        };
        ref = this;
        for (key in ref) {
          value = ref[key];
          payload[key] = value;
        }
        await POST("role.create", {
          role: payload
        });
        this._stored = true;
        return this;
      } else {
        payload = {
          roleId: this.id(),
          name: this.name()
        };
        ref1 = this;
        for (key in ref1) {
          value = ref1[key];
          payload[key] = value;
        }
        await POST("role.update", {
          update: payload
        });
        return this;
      }
    }

    addUser(user) {
      return this._usersMap[user.id()] = true;
    }

    removeUser(user) {
      return delete this._usersMap[user.id()];
    }

    addRole(role) {
      return this._rolesMap[role.id()] = true;
    }

    removeRole(role) {
      return delete this._rolesMap[role.id()];
    }

    getUsers() {
      var ref, results, userId, val;
      ref = this._usersMap;
      results = [];
      for (userId in ref) {
        val = ref[userId];
        results.push(userId);
      }
      return results;
    }

    getRoles() {
      var ref, results, roleId, val;
      ref = this._rolesMap;
      results = [];
      for (roleId in ref) {
        val = ref[roleId];
        results.push(roleId);
      }
      return results;
    }

    async destroy() {
      await POST("role.delete", {
        id: this.id()
      }, "$SYSTEM");
      return this._deleted = true;
    }

    static async list() {
      var i, len, r, results, roles;
      roles = (await GET("roles"));
      results = [];
      for (i = 0, len = roles.length; i < len; i++) {
        r = roles[i];
        results.push(WeaverRole.loadFromServerObject(r));
      }
      return results;
    }

    static async load(roleId) {
      var roleObject;
      roleObject = (await GET('role.read', {
        id: roleId
      }));
      return Weaver.Role.loadFromServerObject(roleObject);
    }

  };

  module.exports = WeaverRole;

}).call(this);
